import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NavLink, useParams } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { authLogin }  from '../../store/authSlice';
import Form  from '../common/Form';
import { post } from '../../utils/api';

const Login = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const params = useParams();
	const [ email, setEmail ] = useState(params.email ? params.email : '');
	const [ password, setPassword ] = useState('');
	const [ disabled, setDisabled ] = useState(true);
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
	const [ showPass, setShowPass ] = useState(false);

	useEffect(() => {
		setDisabled(!(email && password));
	},[email, password]);

	const onSubmit = async () => {
		setIsLoading(true);
        setError('');
		const result = await post('/login', { email, password });
		if(result.error) {
			setError(result.error);
		} else {
			dispatch(authLogin(result.data));
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.token;
			document.body.setAttribute('scheme', result.data.user.role);
		}
        setIsLoading(false);
	};

	return (
		<div>
	    	<h1>{t('login.title')}</h1>
			{isLoading ? <span>{t('common.loading')}</span> :
			<React.Fragment>
				<Form error={t(error)} info={t('login.subtitle')}>
					<label htmlFor='email'>{t('login.email')}</label>
					<input
						id='email'
						type='text'
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
					<label htmlFor='password'>{t('login.password')}</label>
					<div style={{position:'relative'}}>
						<input
							id='password'
							type={showPass ? 'text' : 'password'}
							value={password}
							onChange={e => setPassword(e.target.value)}
						/>
						<div
							style={{
								position: 'absolute',
								top: '0',
								right: '0',
								zIndex: 100,
								padding: '.5rem',
								cursor: 'pointer',
							}}
							onClick={() => setShowPass(!showPass)}
						>
							<Icon icon={showPass ? faEyeSlash : faEye}/>
						</div>
					</div>
					<input
						id='submit'
						type='submit'
						value={t('login.submit')}
						disabled={disabled}
						onClick={onSubmit}
					/>
				</Form>
				<NavLink to={email ? '/cabinet/restore/email/' + email : '/cabinet/restore'}>{t('login.restore')}</NavLink>
			</React.Fragment>}
		</div>
	);
};

export default Login;
